export enum CourseOfferingRecommendationComponentAlignment {
    Left = 'left',
    Center = 'center',
    Right = 'right',
}
